import React, { useEffect, useState } from "react";
import Amplify from "aws-amplify";
import { withAuthenticator } from "aws-amplify-react";
import { Auth } from "aws-amplify";
import config from "../../config";

export const AuthDataContext = React.createContext(null);
export const onStateChangeContext = React.createContext(null);

Amplify.configure({
  Auth: {
    region: "us-east-1",
    userPoolId: config.userPoolId,
    userPoolWebClientId: config.userPoolWebClientId,
    mandatorySignIn: true
  }
});

const SelfHostedAuth = props => {
  const [authData, setAuthData] = useState({});

  const setAuth = () => {
    Auth.currentAuthenticatedUser().then(currentUser => {
      setAuthData(currentUser);
    });
  };

  useEffect(() => {
    setAuth();
  }, []);

  return (
    <AuthDataContext.Provider value={authData}>
      <onStateChangeContext.Provider value={props.onStateChange}>
        {React.cloneElement(props.children, { ...props })}
      </onStateChangeContext.Provider>
    </AuthDataContext.Provider>
  );
};

export default withAuthenticator(SelfHostedAuth);
